<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <employee-account>
        </employee-account> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import EmployeeAccount from './todo-employee-account'
export default {
    components: {
        EmployeeAccount
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-accounts/base-employee-account.vue